<template lang="pug">
el-container.main
  .main-search
    el-form(
      :model="searchForm",
      ref="searchForm",
      label-width="100px",
      :inline="true"
    )
      el-form-item
        el-input.search-input(
          v-model="searchForm.keyword",
          placeholder="卫星名称/NORAD/COSPAR",
          @keyup.enter.native="submitForm('searchForm')"
        )
      el-form-item
        el-button.search-btn(
          type="primary",
          icon="el-icon-search",
          @click="submitForm('searchForm')"
        ) 搜索
        template(v-if="advancedFilter")
          el-button(
            type="text",
            icon="el-icon-arrow-up",
            @click="switchAdvancedFilter"
          ) 高级检索
        template(v-else)
          el-button(
            type="text",
            icon="el-icon-arrow-down",
            @click="switchAdvancedFilter"
          ) 高级检索
  .main-filter(v-show="this.advancedFilter")
    .filter-item
      el-form(
        :model="searchForm",
        ref="searchForm",
        label-width="100px",
        :label-position="labelPosition",
        :inline="formInLine"
      )
        el-form-item(label="卫星类型")
          el-cascader(
            v-model="searchForm.classification",
            :options="satClassificationOptions",
            placeholder="请选择卫星类型",
            clearable
          )
        el-form-item(
          v-if="searchForm.classification.includes('6')",
          label="光谱波段(um)"
        )
          el-col(:span="8")
            el-input(
              placeholder="最小值",
              type="number",
              v-model="searchForm.spectralrange.min"
            )
          el-col.mid-dash(:span="2") -
          el-col(:span="8")
            el-input(
              placeholder="最大值",
              type="number",
              v-model="searchForm.spectralrange.max"
            )
        el-form-item(
          v-if="this.searchForm.classification.includes('7')",
          label="雷达波段"
        )
          el-select(
            v-model="searchForm.sarBand",
            placeholder="请选择雷达波段",
            clearable,
            collapse-tags
          )
            el-option(
              v-for="item in this.sarBandOptions",
              :key="item.value",
              :label="item.label",
              :value="item.value"
            )
        el-form-item(
          v-if="this.searchForm.classification.includes('7')",
          label="扫描模式"
        )
          el-select(
            v-model="searchForm.sarMode",
            placeholder="请选择扫描模式",
            clearable,
            collapse-tags
          )
            el-option(
              v-for="item in this.sarModeOptions",
              :key="item.value",
              :label="item.label",
              :value="item.value"
            )
    .filter-item
      el-form(
        :model="searchForm",
        v-loading="loading",
        ref="searchForm",
        label-width="100px",
        :label-position="labelPosition",
        :inline="formInLine"
      )
        el-form-item(label="轨道级别")
          el-select(
            v-model="searchForm.orbitClass",
            placeholder="请选择轨道级别",
            multiple,
            collapse-tags
          )
            el-option(
              v-for="item in this.orbitClassOptions",
              :key="item.value",
              :label="item.label",
              :value="item.value"
            )
        el-form-item(label="运行状态")
          el-select(
            v-model="searchForm.operStatus",
            placeholder="请选择运行状态",
            multiple,
            collapse-tags
          )
            el-option(
              v-for="item in this.operStatusOptions",
              :key="item.value",
              :label="item.label",
              :value="item.value"
            )
  .main-content
    el-table.pc(
      v-if="items.length > 0",
      :data="items",
      :stripe="true",
      border,
      max-height="640",
      style="width: 100%",
      :header-cell-style="tableHeaderColor"
    )
      el-table-column(prop="name", label="卫星", width="160")
        template(slot-scope="scope")
          router-link(
            :to="{ name: 'satellite-detail', params: { id: scope.row.id.toString() } }"
          ) {{ scope.row.name }}
          el-tooltip(v-if="scope.row.verified" lass="item" effect="light" content="数据已校正" placement="right")
            i.el-icon-success(style="color: green;")
      el-table-column(prop="cosparNum", label="COSPAR", width="120")
        template(slot-scope="scope") {{ scope.row.satcat.cospar }}
      el-table-column(prop="status", label="运行状态")
        template(slot-scope="scope") {{ scope.row.status.label }}
      el-table-column(prop="realm", label="类型")
        template(slot-scope="scope") {{ scope.row.realm ? scope.row.realm.name : '' }}
      el-table-column(prop="orbit_altitude_class", label="轨道级别")
        template(slot-scope="scope") {{ scope.row.orbit_altitude_class.label }}
      el-table-column(prop="satcat.apogee", label="近地点（km）")
      el-table-column(prop="satcat.perigee", label="远地点（km）")
      el-table-column(prop="satcat.period", label="轨道周期（minutes）", width="160")
  .main-pager
    el-pagination.page(
      @size-change="handleSizeChange",
      layout="total, sizes, prev, next, jumper",
      :page-sizes="[10, 20, 50]",
      :current-page.sync="pagination.currentPage",
      :page-size.sync="pagination.pageSize",
      :total="pagination.total"
    )
</template>

<script>
// @ is an alias to /src
import { listSatellite, listOperationalStatus } from "@/services";

export default {
  name: "satellite",
  data() {
    return {
      orbitClassOptions: [
        { value: "LEO", label: "LEO" },
        { value: "MEO", label: "MEO" },
        { value: "GEO", label: "GEO" },
        { value: "HEO", label: "HEO" },
        { value: "UNKNOWN", label: "不详" },
      ],
      operStatusOptions: [
        { value: "+", label: "运行中" },
        { value: "-", label: "停运" },
        { value: "P", label: "部分运行" },
        { value: "B", label: "备机" },
        { value: "S", label: "空闲" },
        { value: "X", label: "附加任务中" },
        { value: "D", label: "已衰减" },
        { value: "?", label: "不详" },
      ],
      sarBandOptions: [
        { value: "C", label: "C-Band" },
        { value: "L", label: "L-Band" },
        { value: "S", label: "S-Band" },
        { value: "X", label: "X-Band" },
      ],
      sarModeOptions: [
        { value: "ScanSAR", label: "ScanSAR" },
        { value: "Stripmap", label: "Stripmap" },
        { value: "Spotlight", label: "Spotlight" },
      ],
      satClassificationOptions: [
        { value: "communications", label: "通信" },
        { value: "navigation", label: "导航" },
        {
          value: "remote-sensing",
          label: "遥感",
          children: [
            {
              value: "6",
              label: "光学",
            },
            {
              value: "7",
              label: "SAR",
            },
          ],
        },
      ],
      loading: false,
      selected: [],
      items: [],
      pagination: {
        total: 1,
        currentPage: 1,
        pageSize: 10,
      },
      advancedFilter: false,
      labelPosition: "left",
      formInLine: true,
      searchForm: {
        keyword: "",
        operStatus: [],
        orbitClass: [],
        classification: [],
        spectralrange: {
          min: null,
          max: null,
        },
        sarBand: [],
        sarMode: [],
      },
      operStatusCheckIndeterminate: false,
      orbitClassCheckIndeterminate: false,
      orbitTypeCheckIndeterminate: false,
      checkAllOperStatus: true,
      checkAllOrbitClass: true,
      checkAllOrbitType: true,
    };
  },
  watch: {
    searchForm: {
      handler() {
        this.pagination.currentPage = 1;
        this.pagination.pageSize = 10;
      },
      deep: true,
      immediate: true,
    },
    "pagination.currentPage": {
      handler() {
        this.fetch();
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * Backend Service API Func Wrapper
     */
    async fetch() {
      this.selected = [];
      this.loading = true;
      const res = await listSatellite({
        size: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ordering: "-launch_date",
        q: this.searchForm.keyword,
        status:
          this.searchForm.operStatus.length === this.operStatusOptions.length
            ? []
            : this.searchForm.operStatus,
        orbit_altitude_class:
          this.searchForm.orbitClass.length === 5
            ? []
            : this.searchForm.orbitClass,
        realm:
          this.searchForm.classification.length === 5
            ? []
            : this.searchForm.classification[0],
        band: this.searchForm.sarBand,
        mode: this.searchForm.sarMode,
        spectral_range:
          this.searchForm.spectralrange.min || this.searchForm.spectralrange.max
            ? [
              this.searchForm.spectralrange.min,
              this.searchForm.spectralrange.max,
            ].join(",")
            : "",
      });
      this.items = res.data.items;
      this.pagination.total = res.data.total;
      this.loading = false;
    },
    /**
     * UI Control
     */
    setFormInLine() {
      if (screen.width > 540) {
        this.formInLine = true;
      } else {
        this.formInLine = false;
      }
    },
    handleSatTrackClick() {
      window.open("https://tracker.vsattech.com");
    },
    handleMapSearchClick() {
      window.open(
        "https://" +
        window.location.hostname.replace("satmeta", "portal") +
        "/search"
      );
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.fetch();
    },
    submitForm() {
      this.fetch();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.fetchOperStatus();
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;color: #8493A8;";
      }
    },
    switchAdvancedFilter() {
      this.advancedFilter = !this.advancedFilter;
    },
    operStatusFormatter(row, column, cellValue) {
      switch (cellValue) {
        case "Operational":
          return "正常运行";
        case "Partially Operational":
          return "部分功能运行";
        case "Backup/Standby":
          return "备用";
        case "Spare":
          return "闲置";
        case "Extended Mission":
          return "扩展任务";
        default:
          return "状态不明";
      }
    },
    orbitClassFormatter(row, column, cellValue) {
      switch (cellValue) {
        case "UNKNOWN":
          return "暂无数据";
        default:
          return cellValue;
      }
    },
    orbitTypeFormatter(row, column, cellValue) {
      switch (cellValue) {
        case "UNKNOWN":
          return "暂无数据";
        default:
          return cellValue;
      }
    },
  },
  mounted() {
    this.setFormInLine();
    this.fetch();
  },
};
</script>
<style lang="stylus" scoped>
.basic-search {
  padding-right: 60px;
}

.search-input {
  width: 360px;
}

.search-btn {
  width: 140px;
}

.mid-dash {
  text-align: center;
}

.adfilter-select {
  width: 270px;
}

.outlink {
  margin-left: 5px;

  &:hover {
    cursor: pointer;
  }
}

.phone {
  display: none;
}

@media only screen and (max-width: 540px) {
  .search-input {
    width: 280px;
  }

  .pc {
    display: none;
  }

  .phone {
    display: inline;
  }
}
</style>
